import React from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  findDisplayName,
  formatNumberWithMask,
  isView,
} from "../../../utils/commonFunctionsAndStatices";
import { Link } from "react-router-dom";
import { setVisitorID } from "../../Store/actions/profile/profileReducer";
import DataNotFound from "../DataNotFound/DataNotFound";
import { setOrganization } from "../../Store/actions/getorganization/organizationSelector";

export const CSROTable = ({ data, POB }) => {
  const organization = useSelector(setOrganization);

  const dispatch = useDispatch();
  const formatDateTime = (timestamp) => {
    if (timestamp === "null" || timestamp === "") {
      return "";
    } else {
      const date = new Date(timestamp);
      const options = { timeZone: "UTC" };
      return date.toLocaleString("en-US", options);
    }
  };
  let offlineLogOut = sessionStorage.getItem("checkout");

  let formetData = JSON.parse(offlineLogOut);
  const dataList = data;
  if (!dataList || dataList?.length === 0) {
    return (
      <div className={`${isView("isLandingCheckIn") ? "card" : ""}`}>
        <DataNotFound />
      </div>
    );
  }

  function getTimeByVisitorId(visitorId) {
    for (let i = 0; i < formetData?.length; i++) {
      const entry = formetData[i];
      const keys = Object.keys(entry);
      if (keys.includes(visitorId)) {
        return entry[visitorId].time;
      }
    }
    return "";
  }

  function findCallingnameById(id) {
    var root = JSON.parse(sessionStorage.getItem("persist:root"));
    var locationList = JSON.parse(root.locationDataArr).locationArr;
    if (locationList.length > 0) {
      const foundItem = locationList?.find((item) => item.locationid === id);
      return foundItem ? foundItem.locationname : null;
    } else {
      var locationList = JSON.parse(root.allLocationData).allLocationData;
      const foundItem = locationList.find((item) => item.locationid === id);
      return foundItem ? foundItem.locationname : null;
    }
  }

  const handleSubmit = (visitorid) => {
    dispatch(setVisitorID(visitorid));
  };

  // Visitor Id based find the visitor name
  function findVisitorTypeById(id) {
    var root = JSON.parse(sessionStorage.getItem("persist:root"));
    var visitorTypeList = JSON.parse(root.visitorTypeTable).visitortable;
    if (visitorTypeList) {
      const foundItem = visitorTypeList?.find((item) => item.visitortypeid === id);
      return foundItem ? foundItem.name : null;
    } else if (!visitorTypeList) {
      var visitorType = JSON.parse(root.visitorType).visitorArr;
      const foundItem = visitorType?.find((item) => item.visitortypeid === id);
      return foundItem ? foundItem.name : null;
    }
  }

  console.log(dataList, "datalist");

  return (
    <div className="container ">
      <div className="row pt-4">
        <div className={` ${isView("isLandingCheckIn") ? "p-2" : ""}`}>
          <div
            className={` ${isView("isLandingCheckIn")
              ? "table-wrapper"
              : "visitorlog-table-scrol"
              }`}
          >
            <table
              className={` ${isView("isLandingCheckIn")
                ? "checkouttable"
                : "table table-striped"
                }`}
            >
              <thead className="bg-transparent">
                <tr>
                  <th scope="col" className="bg-transparent th-color">
                    {findDisplayName("visitorsLogBadgeHeading", "Badge")}
                  </th>
                  <th scope="col" className="bg-transparent th-color">
                    {findDisplayName("visitorsLogNameHeading", "Name")}
                  </th>
                  <th
                    scope="col"
                    style={{ whiteSpace: "nowrap" }}
                    className="bg-transparent th-color"
                  >
                    {findDisplayName(
                      "visitorsLogCallingOnHeading",
                      "Location Name"
                    )}
                  </th>
                  <th
                    scope="col"
                    style={{ whiteSpace: "nowrap" }}
                    className="bg-transparent th-color"
                  >
                    {findDisplayName(
                      "visitorsLogVisitorTypeHeading",
                      "Visitor Type"
                    )}
                  </th>
                  <th scope="col" className="bg-transparent th-color">
                    {findDisplayName("visitorsLogCheckInHeading", "Check-In")}
                  </th>
                  <th scope="col" className="bg-transparent th-color">
                    {findDisplayName(
                      "visitorsLogCheckOutHeading",
                      "Check-Out "
                    )}
                  </th>
                </tr>
              </thead>
              <tbody>
                {dataList?.map((item, index) => (
                  <tr key={index}>
                    <td className="ps-2 bg-transparent text-white">
                      {isView("isVisitorLogProfile") ? (
                        <Link
                          to="/VisitorDetails"
                          style={{ textDecoration: "none", color: "white" }}
                          onClick={() => handleSubmit(item.visitorid)}
                        >
                          {formatNumberWithMask(item.Badge, organization.badge_number_mask)}
                        </Link>
                      ) : (
                        formatNumberWithMask(item.Badge, organization.badge_number_mask)
                      )}
                    </td>
                    <td className="bg-transparent text-white">{item.Name}</td>
                    <td className="bg-transparent text-white">
                      {item.locationid
                        ? findCallingnameById(item.locationid)
                        : ""}
                    </td>
                    <td className="bg-transparent text-white">
                      {item.locationid
                        ? findVisitorTypeById(item.visitortypeid)
                        : ""}
                    </td>
                    <td className="bg-transparent text-white">
                      {item.CheckIn ? formatDateTime(item?.CheckIn) : ""}
                    </td>
                    <td className="bg-transparent text-white">
                      {item.CheckOut ? formatDateTime(item?.CheckOut) : formatDateTime(getTimeByVisitorId(item.visitorid))}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};
